import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import { getBackendUrl } from "../../config";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: "auto",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
}));

const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;

const resolveImageUrl = imageUrl => {
  if (!imageUrl) {
    return "";
  }

  if (
    imageUrl.startsWith("blob:") ||
    imageUrl.startsWith("data:") ||
    ABSOLUTE_URL_PATTERN.test(imageUrl)
  ) {
    return imageUrl;
  }

  const backendUrl = (getBackendUrl() || "").replace(/\/+$/, "");
  const normalizedPath = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;

  return backendUrl ? `${backendUrl}${normalizedPath}` : normalizedPath;
};

const ModalImageCors = ({ imageUrl }) => {
  const classes = useStyles();
  const resolvedImageUrl = useMemo(() => resolveImageUrl(imageUrl), [imageUrl]);
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    let isMounted = true;
    let objectUrl = "";

    if (!resolvedImageUrl) {
      setBlobUrl("");
      return undefined;
    }

    const fetchImage = async () => {
      try {
        const { data, headers } = await api.get(resolvedImageUrl, {
          responseType: "blob",
        });

        objectUrl = window.URL.createObjectURL(
          new Blob([data], { type: headers["content-type"] || data.type })
        );

        if (!isMounted) {
          window.URL.revokeObjectURL(objectUrl);
          return;
        }

        setBlobUrl(objectUrl);
      } catch (error) {
        if (isMounted) {
          setBlobUrl("");
        }
      }
    };

    fetchImage();

    return () => {
      isMounted = false;

      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  }, [resolvedImageUrl]);

  const displayUrl = blobUrl || resolvedImageUrl;

  if (!displayUrl) {
    return null;
  }

  return (
    <ModalImage
      className={classes.messageMedia}
      small={displayUrl}
      smallSrcSet={displayUrl}
      medium={displayUrl}
      large={displayUrl}
      alt="image"
      showRotate
    />
  );
};

export default ModalImageCors;
